import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { ApiResponse, UserPermissionsModel } from '../models';

/**
 * Permissions API Service
 */
@Injectable({
    providedIn: 'root'
})
export class PermissionsService extends BaseApiService {

    /**
     * Check file access
     */
    checkFileAccess(fileId: string, userId: string): Observable<ApiResponse<UserPermissionsModel>> {
        return this.get<UserPermissionsModel>(`/permissions/files/${fileId}/check-access`, { userId });
    }

    /**
     * Check project access
     */
    checkProjectAccess(projectId: string, userId: string): Observable<ApiResponse<UserPermissionsModel>> {
        return this.get<UserPermissionsModel>(`/permissions/projects/${projectId}/check-access`, { userId });
    }

    /**
     * Check file operations
     */
    checkFileOperations(fileId: string, userId: string): Observable<ApiResponse<UserPermissionsModel>> {
        return this.get<UserPermissionsModel>(`/permissions/files/${fileId}/check-operations`, { userId });
    }

    /**
     * Check project modification permissions
     */
    checkProjectModification(projectId: string, userId: string): Observable<ApiResponse<UserPermissionsModel>> {
        return this.get<UserPermissionsModel>(`/permissions/projects/${projectId}/check-modification`, { userId });
    }

    /**
     * Get project permissions for user
     */
    getProjectPermissions(projectId: string, userId: string): Observable<ApiResponse<UserPermissionsModel>> {
        return this.get<UserPermissionsModel>(`/permissions/projects/${projectId}/users/${userId}`);
    }

    /**
     * Get file permissions for user
     */
    getFilePermissions(fileId: string, userId: string): Observable<ApiResponse<UserPermissionsModel>> {
        return this.get<UserPermissionsModel>(`/permissions/files/${fileId}/users/${userId}`);
    }
}



